import OperationalReportListForm from './OperationalReportListForm';

export default OperationalReportListForm;